import { useMutation } from '@tanstack/react-query';
import { ApiRequestOptions, request } from '../utils/api';

type UseApiMutationOptions<TData> = {
  onMutate?: (variables: ApiRequestOptions) => void | Promise<void>;
  onSuccess?: (
    data: TData,
    variables: ApiRequestOptions
  ) => void;
  onError?: (error: unknown) => void;
};

export function useApiMutation<TData = any>(
  options?: UseApiMutationOptions<TData>
) {
  return useMutation<TData, unknown, ApiRequestOptions>({
    mutationFn: (opts) => request<TData>(opts),
    onMutate: options?.onMutate,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
}
